export default __webpack_public_path__ + "cf77338dd5568ea6e43c6609f556011f.png";